import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { GroupService } from 'src/app/services/archive/group.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { GroupImportModel } from './../../../../models/imports/group-import.mode';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-import-group',
  templateUrl: './import-group.component.html',
  styleUrls: ['./import-group.component.scss'],
  standalone: false
})
export class ImportGroupComponent {

  groupImport: boolean = false;
  eventFile: any;
  errorGroup: number = 0;
  groupAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;

  constructor(
    private groupService: GroupService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attach() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.groupImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadGuideImport() {
    this.groupService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaGrupos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.groupAlerts || this.groupAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.groupService.exportImportErrors(this.groupAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionGrupos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importGroups() {
    this.groupAlerts = [];
    this.errorGroup = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<GroupImportModel>();
    let row: GroupImportModel;
    let counter: number = 1, code: string, name: string;
    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }
    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código:
        code = element[0] as string;
        if (code == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código no es válido.`;
          this.groupAlerts.push(alert);
          rowHasError = true;
        } else if (code.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código supera el tamaño máximo de caracteres (3).`;
          this.groupAlerts.push(alert);
          rowHasError = true;
        }

        //B. Nombre:
        name = element[1] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre no es válido.`;
          this.groupAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre supera el tamaño máximo de caracteres (50).`;
          this.groupAlerts.push(alert);
          rowHasError = true;
        }

        if (!rowHasError) {
          row = new GroupImportModel(counter, code, name);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorGroup = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportGroups(rowsImports);
    });
  }

  async processImportGroups(rowsImports: Array<GroupImportModel>) {
    try {
      const response = await firstValueFrom(this.groupService.importGroups(rowsImports));
      this.loadPreInvoicingModel = response;
      this.groupAlerts = response?.alerts ?? [];
      this.errorGroup = response?.preInvoicingStateId;

      if (this.errorGroup === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.groupAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.groupImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Grupos.', error);
    }
  }
}
